<template>
    <div class="" v-if="!playing">
        <div
            class="flex items-center gap-2 rounded rounded-full bg-primary-500 px-3 py-2 text-white hover:cursor-pointer hover:bg-primary-400"
        >
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.6383 8.63647C16.6879 9.24248 16.6879 10.7575 15.6383 11.3635L8.3617 15.5647C7.31206 16.1707 6 15.4132 6 14.2011L6 5.79885C6 4.58683 7.31206 3.82931 8.3617 4.43533L15.6383 8.63647Z"
                    fill="white"
                />
            </svg>

            <span @click="play">Play</span>
        </div>
    </div>
    <div v-show="playing">
        <div class="jwplayer-audio-container">
            <div :id="'jwplayer-podcast-id' + podcast.id"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: "podcast-player",
    props: {
        podcast: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            playing: false,
        };
    },
    methods: {
        play() {
            let vm = this;
            vm.playing = true;

            let player = window
                .jwplayer("jwplayer-podcast-id" + vm.podcast.id)
                .setup({
                    key: window.jwplayerKey,
                    file:
                        "//content.jwplatform.com/manifests/" +
                        vm.podcast.token +
                        ".m3u8",
                    autostart: false,
                    displaytitle: false,
                    mute: false,
                    controls: true,
                    repeat: false,
                    height: "40px",
                    width: "300px",
                    stretching: "exact",
                    position: 0,
                });

            player.play();
        },
    },
    mounted() {},
};
</script>

<style lang="postcss">
.jwplayer {
    @apply rounded bg-primary-500 text-white;
}

.jw-controllbar,
.jw-button-container {
    @apply !bg-primary-500;
}
</style>
